import { api } from './api';

export interface RiskFactorDTO {
  category: string;
  severity: 'low' | 'medium' | 'high';
  description: string;
  recommendation: string;
  clause_text?: string;
}

export interface RiskFixResponse {
  new_text: string;
  reason: string;
}

export const contractsService = {
  async suggestRiskFix(params: {
    original_text: string;
    risk: RiskFactorDTO;
    party_role?: string;
  }): Promise<RiskFixResponse> {
    // Prefer POST to avoid 414 (URI Too Long) with big documents
    try {
      const { data } = await api.post<RiskFixResponse>('/contracts/test/suggest-fix', params);
      return data;
    } catch (err: any) {
      const status = err?.response?.status;
      if (status === 404 || status === 405) {
        // Fallback to primary route (also POST)
        try {
          const { data } = await api.post<RiskFixResponse>('/contracts/suggest-fix', params);
          return data;
        } catch (err2: any) {
          const status2 = err2?.response?.status;
          if (status2 === 404 || status2 === 405) {
            // Final fallback: use multi-agent consultation with strict JSON instruction
            const prompt = [
              'ÚKOL: Navrhni přesné nové znění smluvní klauzule tak, aby odstranilo níže popsané riziko.',
              'Piš česky. NEUVÁDĚJ žádné odkazy na zákony. Vrať pouze JSON objekt s klíči new_text a reason.',
              '',
              'KONTEKST:',
              params.original_text.slice(0, 6000),
              '',
              'RIZIKO:',
              `- kategorie: ${params.risk.category}`,
              `- závažnost: ${params.risk.severity}`,
              `- popis: ${params.risk.description}`,
              `- doporučení: ${params.risk.recommendation}`,
              params.risk.clause_text ? `- problematická klauzule: "${params.risk.clause_text}"` : '',
              '',
              'FORMÁT ODPOVĚDI: {"new_text":"...","reason":"..."}',
            ].join('\n');

            const { data } = await api.post<any>('/consultation/multi-agent', {
              question: prompt,
              use_web_search: false,
              use_rag: false,
              language: 'cs',
            });

            let newText = '';
            let reason = '';
            try {
              const resp = data?.response || '';
              const start = resp.indexOf('{');
              const end = resp.lastIndexOf('}');
              if (start >= 0 && end > start) {
                const obj = JSON.parse(resp.slice(start, end + 1));
                newText = String(obj.new_text || '').trim();
                reason = String(obj.reason || '').trim();
              }
            } catch {}

            if (!newText) {
              // Fallback: use first lines as suggestion
              const plain = String(data?.response || '').trim();
              newText = plain.slice(0, 800);
              reason = reason || 'AI návrh z multi-agent odpovědi (volný formát).';
            }
            return { new_text: newText, reason };
          }
          throw err2;
        }
      }
      throw err;
    }
  },
};
